
import Vue from "vue";
import store from "../../store/shop";
import _ from "lodash";
import moment from "moment";
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { Effect } from "../../model/menu";
import ShopAPI from "../../common/api/api_shop";
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import notificationMixin from "../../mixin/notification";
import { SessionStatus } from "../../model/entity/tableSessionSetting";
import { CustomerCountType } from "../../model/entity/shopSetting";

const api = new ShopAPI();
const ModalPopup = () => import("../elements/QModal.vue");
let popupConfirm;
let current_session_id = null;
let current_table_index = null;
let current_seat_index = null;
let current_session_data = null;
let move_table_index = null;

const translator = TranslateServiceBuilder.Instance()._;

Vue.component(VueQrcode.name, VueQrcode);

export default Vue.component("SHTableSessionCard", {
  components: {
    QTranslate: () => import("../../components/elements/QTranslate.vue"),
    SHChangePeoplePopup: () => import("../compositions/SHChangePeoplePopup.vue"),
  },
  mixins: [notificationMixin],
  data() {
    return {
      displayPopup:  false,
      displayPopupQrcode: false,
      displayQrcode: false,
      isOpenPopupChangePeople: false,
      seat_id_move_to: null,
      tableSessionSelected: {
        id: null
      },
      quantities: {
        adult: 0,
        male: 0,
        female: 0,
        child: 0,
      },
      qrCode: "",
      displayTitle: "",
      isLoading: false,
      isChangePeople: false,
    };
  },
  props: {
    table: {
      type: Object,
      required: true,
    },
    isSelfType: {
      type: Boolean,
      required: true,
    },
    table_index: null
  },
  mounted() {
    api.set_token(store.state.token);
  },
  computed: {
    effectStyle: () => (effect: Effect) => {
      let className = {};
      if (!effect.limit_option) {
        className = {
          TimeStarted: true,
        };
      } else if (!_.isNull(effect.start_time)) {
        const lastTime = moment(effect.last_order_time);
        const currentTime = moment();
        const remainTime = lastTime.diff(currentTime, "minutes");
        if (currentTime.isAfter(lastTime)) {
          className = {
            TimeExceeded: true,
          };
        } else if (remainTime < 10) {
          // before 10 minutes
          className = {
            TimeBeforeTenMinute: true,
          };
        } else {
          className = {
            TimeStarted: true,
          };
        }
      }
      return className;
    },
    isStart: () => (effect: Effect) => {
      if (!effect.limit_option) {
        return true;
      }
      return !_.isNull(effect.start_time);
    },
    effectLimitTitle: () => (effect: Effect) => {
      if (effect.end_time) {
        const endTime = moment(effect.end_time).format("HH:mm");
        const lastTime = moment(effect.last_order_time).format("HH:mm");
        return `${endTime} (L.O. ${lastTime})`;
      }
        return "--:-- (L.O. --:--)";
    },
    prefix() {
      return this.$route.params.prefix;
    },
    shoppix() {
      return this.$route.params.shoppix;
    },
    moveListTables() {
      const listTables = [];
      _.forEach(store.state.tableGroups, (tableGroup) => {
        const table_seats = [];
        let isEmpty = false;
        const temp = _.cloneDeep(tableGroup);
        _.forEach(tableGroup.table_seats, (table_seat) => {
          if (!table_seat.table_sessions.length) {
            table_seats.push(table_seat)
            isEmpty = true;
          }
        });

        if (isEmpty) {
          temp.table_seats = table_seats;
          listTables.push(temp)
        }
      });

      return listTables;
    },
    disableButton() {
      return !this.seat_id_move_to || this.isLoading;
    },
    canUseEatIn(): boolean {
      return store.getters.canUseEatIn;
    },
  },
  filters: {
    isActive: (table) => {
      if (table.active === false) {
        return "disabled";
      }
    },
    tableStatusLabel(seat): string {
        if (seat === undefined) {
            return '';
        }
        const session = seat.table_sessions[0];
      switch(session.status) {
          case SessionStatus.STATUS_PAYING:
              return 'paying';
      }

      return '';
    },
  },
  methods: {
    handleClickReturn: function () {
      this.isChangePeople = false;
      this.displayPopupQrcode = false;
    },
    openCategoryOptionPopup(tId) {
      // 砂時計ボタン: 操作待ち（コース開始処理）のリッチポップアップを当該テーブルで開く
      store.commit("requestOpenCategoryOption", tId);
    },
    getTableSessionId(seat) {
      if (seat.table_sessions.length) {
        return seat.table_sessions[0].id;
      }

      return null;
    },
    formatTime(time) {
      if (time) {
        return moment(time).format("HH:mm");
      }

      return null;
    },
    displayQuantity(number) {
      if (number) {
        return `${number}名様`;
      }

      return null;
    },
    displayChild(number) {
        if (
            store.state.shopSetting.customer_count_type === CustomerCountType.ADULT_AND_CHILD
            || store.state.shopSetting.customer_count_type === CustomerCountType.GENDER_AND_CHILD
        ) {
            return `(${number ? number : 0}名様)`;
        }
        return '';
    },
    effects(table_session_id) {
      const sessionEffect = store.state.tableSessions.find(
        (table) => table.id === table_session_id
      );

      if (!sessionEffect) {
        return null;
      }

      const effets = _.uniqBy(sessionEffect.table_session_effects, "order_id") as Effect[];

      if (effets.length) {
        return effets;
      }

      return null;
    },
    setSessionChangeFrom(id, seat_index, table_index, table_session) {
      current_table_index = table_index;
      current_seat_index = seat_index;
      current_session_id = id;
      current_session_data = table_session;
    },
    setSeatChangeTo(event, id, table_index) {
      move_table_index = table_index;
      this.seat_id_move_to = event.target.checked ? id : null;
    },
    isCheck(id) {
      return id === this.seat_id_move_to;
    },
    changeSeat() {
      this.isLoading = true;
      let message = '';
      const data = {
        session_id: current_session_id,
        seat_id_move_to: this.seat_id_move_to,
      };

      api
        .move_seat(data)
        .then((response) => {
          if (response.data.status !== "success") {
            message = translator("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }

          message = response.data.message;
          this.showSuccessNotification(message);
          const tables = _.cloneDeep(store.state.tableGroups);
          _.map(tables[move_table_index].table_seats, (table_seat) => {
            if (table_seat.id === this.seat_id_move_to) {
              table_seat.table_sessions = current_session_data;
            }
          });

          tables[current_table_index].table_seats[current_seat_index].table_sessions = [];
          store.dispatch("setTableGroups", tables);

          this.displayPopup = false;
          this.isLoading = false;
          this.seat_id_move_to = null;
          this.showSuccessNotification(translator("hall-0241", "座席の移動に成功しました。"));

          this.displayPopupQrcode = true;
        })
        .catch((err) => {
          message =
            err.response.data.message ||
            translator("hall-0046", "保存に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
          this.isLoading = false;
        });
    },
    qrReissue() {
      this.isLoading = true;
      let message = '';
      const data = {
        table_session_id: current_session_id,
      };

      api
        .qr_reissue(data)
        .then((response) => {
          if (response.data.status !== "success") {
            message = translator("hall-0256", "QRコードの再発行に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            return;
          }
          this.displayPopupQrcode = false;
          this.isLoading = false;
          this.current_session_id = null;
          this.isChangePeople = false;
          this.showSuccessNotification(translator("hall-0255", "QRコードを再発行しました。"));
        })
        .catch((err) => {
          message = translator("hall-0256", "QRコードの再発行に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
          this.isLoading = false;
          this.isChangePeople = false;
        });
    },
    getQrCode(table_session_id, name) {
      this.loading = true;
      let message = '';
      const data = {
        table_session_id: table_session_id,
      };
      api.qrcode(data)
        .then((response) => {
          if (response.data.status === "success") {
            this.qrCode = response.data.qrcode;
            this.displayTitle = name;
            this.displayQrcode = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          message = translator("hall-0048", "データの取得に失敗しました。");
          this.showErrorNotification(message);
          this.errors = message;
          this.isLoading = false;
        });
    },
    ChangePeople: function (table_session) {
      if (table_session) {
        this.tableSessionSelected = table_session;
        this.quantities.adult = table_session.quantity_adult;
        this.quantities.male = table_session.quantity_male;
        this.quantities.female = table_session.quantity_female;
        this.quantities.child = table_session.quantity_child;
        current_session_id = table_session.id;
        this.isOpenPopupChangePeople = true;
      }
    },
    changedPeople: function() {
      this.closePopup();
      this.isLoading = false;
      store.dispatch("fetchTableSessions");
    },
    closePopup: function () {
      this.isOpenPopupChangePeople = false;
      this.isChangePeople = false;
    },
    closeSuccessPopup: function () {
      this.isChangePeople = true;
      this.displayPopupQrcode = true;
    },
    closeQrCode: function () {
      this.displayQrcode = false;
    },
  },
});
